export default __webpack_public_path__ + "static/media/tours.a8a72a24.png";